module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xNTkxIDE0NDhxNTYgODkgMjEuNSAxNTIuNXQtMTQwLjUgNjMuNWgtMTE1MnEtMTA2IDAtMTQwLjUtNjMuNXQyMS41LTE1Mi41bDUwMy03OTN2LTM5OWgtNjRxLTI2IDAtNDUtMTl0LTE5LTQ1IDE5LTQ1IDQ1LTE5aDUxMnEyNiAwIDQ1IDE5dDE5IDQ1LTE5IDQ1LTQ1IDE5aC02NHYzOTl6bS03NzktNzI1bC0yNzIgNDI5aDcxMmwtMjcyLTQyOS0yMC0zMXYtNDM2aC0xMjh2NDM2eiIvPjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flask.svg
// module id = 154
// module chunks = 0